import { Observable, BehaviorSubject, of as observableOf } from 'rxjs';
import { mergeMap, catchError, share } from "rxjs/operators";
import { AuthenticationService } from '../AuthenticationService';
import { addProvider, IProviderDescriptor } from "../ServiceUtil";
import { ResourceDelegate } from "./resource.delegate";
import { INewResourceBulk, 
INewResourceDocument, 
IResource, 
IResourceDocument, 
IResourceResponse, 
IResourceWorkExperience } from "./resource.interface";

export class ResourceService
{
   
    public resourceData: IResource[] = null;
    private resourcesubject: BehaviorSubject<IResource[]> = new BehaviorSubject(null);
    public resources: Observable<IResource[]> = this.resourcesubject;

    private selectedResourceId: string = "0";
    public selectedResourceData: IResource = null;
    private selectedResourcesubject: BehaviorSubject<IResource> = new BehaviorSubject(null);
    public selectedResource: Observable<IResource> = this.selectedResourcesubject;

    constructor(private resourceDelegate: ResourceDelegate, private authenticationService: AuthenticationService)
    {
    }

    public get resourceId(): string
    {
        return this.selectedResourceId;
    }

    public setSelectedResourceId(resourceId: string): void
    {
        this.selectedResourceId = resourceId;
    }

    public getAllResources(hardReload: boolean = false)
    {
        if (this.resourceData !== null && this.resourceData.length > 0 && hardReload === false)
        {
            return;
        }
        const orgId = this.authenticationService.GetOrgId();

        const response = this.resourceDelegate.getAllResources(orgId);
        return this.processResources(response);
    }

    public getSelectedResource(): IResource
    {
        return this.resourceData.find(resource => resource.resourceUniqueId === this.selectedResourceId);
    }

    public createWorkExperience(respurceExperience: IResourceWorkExperience): Observable<boolean>
    { 
        var response = this.resourceDelegate.createNewResourceExperience({
            ...respurceExperience,
            ...this.authenticationService.getBaseRequest
        });
        return this.processResource(response);
    }

    public createNewResourceDocuments(resourceDocs: INewResourceDocument): Observable<boolean>
    {
        const response = this.resourceDelegate.createResourceDocuments({
            ...resourceDocs,
            ...this.authenticationService.getBaseRequest
        });
        return this.processResource(response);
    }

    public updateWorkExperience(respurceExperience: IResourceWorkExperience): Observable<boolean>
    {
        var response = this.resourceDelegate.updateResourceExperience({
            ...respurceExperience,
            ...this.authenticationService.getBaseRequest
        });
        return this.processResource(response);
    }

    public getResourceById(resourceId: string): Observable<boolean>
    {
        if (resourceId === "0")
        {
            this.selectedResourceData = null;
            this.selectedResourcesubject.next(this.selectedResourceData);
            return observableOf(false);
        }
        var response = this.resourceDelegate.getResourceDetailById(resourceId);
        return this.processResource(response);
    }

    public createNewResourceBulk(benchLead: INewResourceBulk): Observable<boolean>
    {
        const response = this.resourceDelegate.createNewResourceBulk({
            ...benchLead,
            ...this.authenticationService.getBaseRequest
        });
        return this.processResources(response);
    }

    public createNewResource(resource: IResource): Observable<boolean>
    {
        const response = this.resourceDelegate.createNewresource({
            ...resource,
            ...this.authenticationService.getBaseRequest
        });
        return this.processResources(response);
    }

    public updateResource(resource: IResource): Observable<boolean>
    {
        const response = this.resourceDelegate.updateResource({
            ...resource,
            ...this.authenticationService.getBaseRequest
        });
        return this.processResources(response);
    }

    private processResources(resourceResponse: Observable<IResourceResponse>): Observable<boolean>
    {
        resourceResponse.subscribe(onSuccess.bind(this), onFault.bind(this));

        return resourceResponse.pipe(mergeMap((response: IResourceResponse) => observableOf(response.success)),
            catchError(() => observableOf(false)),
            share());

        function onSuccess(resourceResponse: IResourceResponse)
        {
            if (resourceResponse.success)
            {
                this.selectedResourceId = resourceResponse.resourceId ?
                    resourceResponse.resourceId :
                    this.selectedResourceId;
                if (resourceResponse.resources.length > 0 || resourceResponse.resources.length === 0)
                {
                    this.resourceData = resourceResponse.resources;
                    this.resourcesubject.next(this.resourceData);
                }
            }
        }

        function onFault(error: any)
        {
            // ResourceService.logger.error(`processResources Fault - Error (${JSON.stringify(error)})`);
        }
    }

    private processResource(resourceResponse: Observable<IResourceResponse>): Observable<boolean>
    {
        resourceResponse.subscribe(onSuccess.bind(this), onFault.bind(this));

        return resourceResponse.pipe(mergeMap((response: IResourceResponse) => observableOf(response.success)),
            catchError(() => observableOf(false)),
            share());

        function onSuccess(resourceResponse: IResourceResponse)
        {
            if (resourceResponse.success)
            {
                this.selectedResourceId = resourceResponse.resourceId ?
                    resourceResponse.resourceId :
                    this.selectedResourceId;

                this.selectedResourceData = resourceResponse.resource;

                this.selectedResourcesubject.next(this.selectedResourceData);

            }
        }

        function onFault(error: any)
        {
            // ResourceService.logger.error(`processResources Fault - Error (${JSON.stringify(error)})`);
        }
    }
}